/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/

// Inject CSS to hide color variants when modal has data-has-siblings attribute
(function() {
  const style = document.createElement('style');
  style.id = 'quickview-hide-color-variants-css';
  style.textContent = `
    [data-quick-add-modal][data-has-siblings="true"] .native-variants-color,
    [data-quick-add-modal][data-has-siblings="true"] .selector-wrapper.native-variants-color,
    [data-quick-add-modal][data-has-siblings="true"] .native-variants-color * {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      max-height: 0 !important;
      overflow: hidden !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 0 !important;
      pointer-events: none !important;
    }
    
    /* Also hide when product__siblings exists (backup) */
    [data-quick-add-modal] product-info:has(.product__siblings) .native-variants-color,
    [data-quick-add-modal] product-info:has(.product__siblings) .selector-wrapper.native-variants-color {
      display: none !important;
      visibility: hidden !important;
      opacity: 0 !important;
      height: 0 !important;
      max-height: 0 !important;
      overflow: hidden !important;
      margin: 0 !important;
      padding: 0 !important;
      line-height: 0 !important;
      pointer-events: none !important;
    }
  `;
  
  // Remove existing style if present
  const existing = document.getElementById('quickview-hide-color-variants-css');
  if (existing) {
    existing.remove();
  }
  
  document.head.appendChild(style);
  console.log('Quickview: CSS injected for data-has-siblings attribute');
})();

(function() {
  // Add custom code below this line

  /**
   * Quickview Modal Variant ID Fix
   * Ensures the correct variant ID is selected when adding products from quickview modal
   */
  console.log('Quickview: Custom script loaded');

  // Track initialized product-info elements to avoid duplicate listeners
  const initializedProductInfos = new WeakSet();
  
  // Store selected size before modal reload (when product__siblings changes color)
  let lastSelectedSize = null;

  // Listen for when the quickview modal opens
  document.addEventListener('theme:quick-add:open', function() {
    console.log('Quickview: Modal opened event received');
    
    // Immediately try to hide color variants when modal opens
    hideColorVariantsInQuickview();
    setTimeout(hideColorVariantsInQuickview, 10);
    setTimeout(hideColorVariantsInQuickview, 50);
    
    // Wait a bit for the DOM to be fully inserted
    setTimeout(function() {
      initQuickviewVariantUpdate();
    }, 100);
  });

  // Observe the modal content container for when it gets reloaded
  function observeModalContentReload() {
    const quickviewModal = document.querySelector('[data-quick-add-modal][open]');
    if (!quickviewModal) return;

    const modalContent = quickviewModal.querySelector('[data-product-upsell-ajax]');
    if (!modalContent) return;

    // Create a MutationObserver to watch for content changes
    const contentObserver = new MutationObserver(function(mutations) {
      // Check if innerHTML was changed (content reloaded)
      const hasContentChange = mutations.some(mutation => 
        mutation.type === 'childList' && mutation.addedNodes.length > 0
      );

      if (hasContentChange) {
        console.log('Quickview: Modal content reloaded, re-initializing...');
        // Immediately mark modal and hide color variants when content reloads
        markModalWithSiblingsAttribute();
        hideColorVariantsInQuickview();
        setTimeout(function() {
          markModalWithSiblingsAttribute();
          hideColorVariantsInQuickview();
          setupAggressiveColorVariantObserver();
        }, 10);
        setTimeout(function() {
          markModalWithSiblingsAttribute();
          hideColorVariantsInQuickview();
        }, 50);
        setTimeout(function() {
          markModalWithSiblingsAttribute();
          hideColorVariantsInQuickview();
        }, 100);
        
        // Clear the initialized set so we can re-initialize
        const newProductInfo = quickviewModal.querySelector('product-info');
        if (newProductInfo && initializedProductInfos.has(newProductInfo)) {
          // The product-info was replaced, so we need to re-initialize
          initializedProductInfos.delete(newProductInfo);
        }
          // Wait a bit for the new content to be fully inserted
        setTimeout(function() {
          initQuickviewVariantUpdate();
          // After initialization, wait a bit more and then update variant from selected options
          // This ensures we catch the correct variant after the modal reloads (e.g., when changing color in siblings)
          // Use multiple timeouts to catch the variant at different stages of loading
          setTimeout(function() {
            const reloadedProductInfo = quickviewModal.querySelector('product-info');
            if (reloadedProductInfo) {
              console.log('Quickview: Content reloaded (400ms), checking for selected options...');
              
              // Find all selected options (both color from siblings and size)
              const variantSelects = reloadedProductInfo.querySelector('variant-selects');
              if (variantSelects) {
                // Find all selected radio inputs
                const allCheckedInputs = variantSelects.querySelectorAll('input[type="radio"]:checked');
                console.log('Quickview: Found', allCheckedInputs.length, 'selected options after reload');
                
                // If no size is selected, try to restore the last selected size, or use the first size option
                // This is critical because after modal reload, the size selection is lost
                const sizeInputs = variantSelects.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="option2"]');
                const checkedSizeInput = Array.from(sizeInputs).find(input => input.checked);
                if (!checkedSizeInput && sizeInputs.length > 0) {
                  // First, try to restore the last selected size
                  let sizeToSelect = null;
                  if (lastSelectedSize) {
                    const matchingSizeInput = Array.from(sizeInputs).find(input => input.value === lastSelectedSize);
                    if (matchingSizeInput) {
                      sizeToSelect = matchingSizeInput;
                      console.log('Quickview: Restoring last selected size after reload:', lastSelectedSize);
                    } else {
                      console.log('Quickview: Last selected size', lastSelectedSize, 'not found in available sizes, using first size option');
                    }
                  }
                  
                  // If we couldn't restore, use the first size option
                  if (!sizeToSelect) {
                    sizeToSelect = sizeInputs[0];
                    console.log('Quickview: No size selected after reload, selecting first size option:', sizeToSelect.value);
                  }
                  
                  sizeToSelect.checked = true;
                  sizeToSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  console.log('Quickview: Selected size option:', sizeToSelect.value);
                } else if (checkedSizeInput) {
                  // If a size is already selected, update our stored value
                  lastSelectedSize = checkedSizeInput.value;
                  console.log('Quickview: Size already selected after reload, updating stored value:', lastSelectedSize);
                }
                
                // Trigger change events on all selected inputs to update variant
                allCheckedInputs.forEach(function(input) {
                  console.log('Quickview: Triggering change on selected option:', input.name, '=', input.value);
                  input.dispatchEvent(new Event('change', { bubbles: true }));
                });
              }
            }
          }, 400);
          
          // Try again after more time to catch size selection
          setTimeout(function() {
            const reloadedProductInfo = quickviewModal.querySelector('product-info');
            if (reloadedProductInfo) {
              console.log('Quickview: Content reloaded (800ms), re-checking for selected options...');
              
              const variantSelects = reloadedProductInfo.querySelector('variant-selects');
              if (variantSelects) {
                // Check if size is selected, if not, restore the last selected size or use the first one
                const sizeInputs = variantSelects.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="option2"]');
                const checkedSizeInput = Array.from(sizeInputs).find(input => input.checked);
                if (!checkedSizeInput && sizeInputs.length > 0) {
                  // First, try to restore the last selected size
                  let sizeToSelect = null;
                  if (lastSelectedSize) {
                    const matchingSizeInput = Array.from(sizeInputs).find(input => input.value === lastSelectedSize);
                    if (matchingSizeInput) {
                      sizeToSelect = matchingSizeInput;
                      console.log('Quickview: Restoring last selected size after reload (800ms):', lastSelectedSize);
                    }
                  }
                  
                  // If we couldn't restore, use the first size option
                  if (!sizeToSelect) {
                    sizeToSelect = sizeInputs[0];
                    console.log('Quickview: No size selected after reload (800ms), selecting first size option:', sizeToSelect.value);
                  }
                  
                  sizeToSelect.checked = true;
                  sizeToSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  console.log('Quickview: Selected size option (800ms):', sizeToSelect.value);
                }
                
                const allCheckedInputs = variantSelects.querySelectorAll('input[type="radio"]:checked');
                console.log('Quickview: Found', allCheckedInputs.length, 'selected options after reload (800ms)');
                
                if (allCheckedInputs.length > 0) {
                  allCheckedInputs.forEach(function(input) {
                    console.log('Quickview: Triggering change on selected option (800ms):', input.name, '=', input.value);
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                  });
                }
              }
            }
          }, 800);
          
          // Final attempt after even more time
          setTimeout(function() {
            const reloadedProductInfo = quickviewModal.querySelector('product-info');
            if (reloadedProductInfo) {
              console.log('Quickview: Content reloaded (1200ms), final check for selected options...');
              
              const variantSelects = reloadedProductInfo.querySelector('variant-selects');
              if (variantSelects) {
                // Check if size is selected, if not, restore the last selected size or use the first one
                const sizeInputs = variantSelects.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="option2"]');
                const checkedSizeInput = Array.from(sizeInputs).find(input => input.checked);
                if (!checkedSizeInput && sizeInputs.length > 0) {
                  // First, try to restore the last selected size
                  let sizeToSelect = null;
                  if (lastSelectedSize) {
                    const matchingSizeInput = Array.from(sizeInputs).find(input => input.value === lastSelectedSize);
                    if (matchingSizeInput) {
                      sizeToSelect = matchingSizeInput;
                      console.log('Quickview: Restoring last selected size after reload (1200ms):', lastSelectedSize);
                    }
                  }
                  
                  // If we couldn't restore, use the first size option
                  if (!sizeToSelect) {
                    sizeToSelect = sizeInputs[0];
                    console.log('Quickview: No size selected after reload (1200ms), selecting first size option:', sizeToSelect.value);
                  }
                  
                  sizeToSelect.checked = true;
                  sizeToSelect.dispatchEvent(new Event('change', { bubbles: true }));
                  console.log('Quickview: Selected size option (1200ms):', sizeToSelect.value);
                }
                
                const allCheckedInputs = variantSelects.querySelectorAll('input[type="radio"]:checked');
                console.log('Quickview: Found', allCheckedInputs.length, 'selected options after reload (1200ms)');
                
                if (allCheckedInputs.length > 0) {
                  allCheckedInputs.forEach(function(input) {
                    console.log('Quickview: Triggering change on selected option (1200ms):', input.name, '=', input.value);
                    input.dispatchEvent(new Event('change', { bubbles: true }));
                  });
                }
              }
            }
          }, 1200);
        }, 150);
      }
    });

    contentObserver.observe(modalContent, {
      childList: true,
      subtree: true
    });

    console.log('Quickview: Content reload observer attached');
  }

  // Set up observer when modal opens
  document.addEventListener('theme:quick-add:open', function() {
    setTimeout(observeModalContentReload, 50);
  });

  // Function to mark modal with dynamic attribute when product__siblings exists
  function markModalWithSiblingsAttribute() {
    const quickviewModal = document.querySelector('[data-quick-add-modal][open]');
    if (!quickviewModal) return;

    const productInfo = quickviewModal.querySelector('product-info');
    if (!productInfo) return;

    // Check if product__siblings exists
    const productSiblings = productInfo.querySelector('.product__siblings');
    const plSwatches = productInfo.querySelector('#pl-swatches-embed-copied');
    
    if (productSiblings || plSwatches) {
      // Add dynamic attribute to modal to mark it as having siblings
      quickviewModal.setAttribute('data-has-siblings', 'true');
      console.log('Quickview: Modal marked with data-has-siblings="true"');
    } else {
      quickviewModal.removeAttribute('data-has-siblings');
    }
  }

  // Function to aggressively hide color variants in quickview modal
  function hideColorVariantsInQuickview() {
    const quickviewModal = document.querySelector('[data-quick-add-modal][open]');
    if (!quickviewModal) return;

    const productInfo = quickviewModal.querySelector('product-info');
    if (!productInfo) return;

    // Check if modal has the siblings attribute OR if product__siblings exists
    const hasSiblingsAttr = quickviewModal.hasAttribute('data-has-siblings');
    const productSiblings = productInfo.querySelector('.product__siblings');
    const plSwatches = productInfo.querySelector('#pl-swatches-embed-copied');
    
    if (hasSiblingsAttr || productSiblings || plSwatches) {
      // Update attribute if siblings exist but attribute not set
      if (!hasSiblingsAttr && (productSiblings || plSwatches)) {
        quickviewModal.setAttribute('data-has-siblings', 'true');
      }
      
      // Find and hide ALL color variants immediately
      const colorVariants = productInfo.querySelectorAll('.native-variants-color');
      colorVariants.forEach(variant => {
        variant.style.setProperty('display', 'none', 'important');
        variant.style.setProperty('visibility', 'hidden', 'important');
        variant.style.setProperty('opacity', '0', 'important');
        variant.style.setProperty('height', '0', 'important');
        variant.style.setProperty('overflow', 'hidden', 'important');
        variant.style.setProperty('margin', '0', 'important');
        variant.style.setProperty('padding', '0', 'important');
        variant.style.setProperty('max-height', '0', 'important');
        variant.style.setProperty('line-height', '0', 'important');
      });
      
      // Also hide parent containers if they only contain color variants
      const variantSelects = productInfo.querySelector('variant-selects');
      if (variantSelects) {
        const selectorWrappers = variantSelects.querySelectorAll('.selector-wrapper.native-variants-color');
        selectorWrappers.forEach(wrapper => {
          wrapper.style.setProperty('display', 'none', 'important');
        });
      }
      
      if (colorVariants.length > 0) {
        console.log('Quickview: Aggressively hid', colorVariants.length, 'color variant elements');
      }
    }
  }

  // Aggressive MutationObserver that watches for .native-variants-color elements being added
  function setupAggressiveColorVariantObserver() {
    const quickviewModal = document.querySelector('[data-quick-add-modal][open]');
    if (!quickviewModal) return;

    const productInfo = quickviewModal.querySelector('product-info');
    if (!productInfo) return;

    // Check if siblings exist
    const productSiblings = productInfo.querySelector('.product__siblings');
    const plSwatches = productInfo.querySelector('#pl-swatches-embed-copied');
    
    if (!productSiblings && !plSwatches) return;

    // Function to hide any color variants found
    function hideAnyColorVariants() {
      const colorVariants = productInfo.querySelectorAll('.native-variants-color');
      if (colorVariants.length > 0) {
        colorVariants.forEach(variant => {
          variant.style.setProperty('display', 'none', 'important');
          variant.style.setProperty('visibility', 'hidden', 'important');
          variant.style.setProperty('opacity', '0', 'important');
          variant.style.setProperty('height', '0', 'important');
          variant.style.setProperty('overflow', 'hidden', 'important');
          variant.style.setProperty('margin', '0', 'important');
          variant.style.setProperty('padding', '0', 'important');
          variant.style.setProperty('max-height', '0', 'important');
          variant.style.setProperty('line-height', '0', 'important');
        });
        
        const variantSelects = productInfo.querySelector('variant-selects');
        if (variantSelects) {
          const selectorWrappers = variantSelects.querySelectorAll('.selector-wrapper.native-variants-color');
          selectorWrappers.forEach(wrapper => {
            wrapper.style.setProperty('display', 'none', 'important');
          });
        }
      }
    }

    // Observer that watches for ANY .native-variants-color being added to the DOM
    const aggressiveObserver = new MutationObserver(function(mutations) {
      let shouldHide = false;
      
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === 1) { // Element node
              // Check if the added node is a color variant or contains one
              if (node.classList && node.classList.contains('native-variants-color')) {
                shouldHide = true;
                // Hide immediately
                node.style.setProperty('display', 'none', 'important');
                node.style.setProperty('visibility', 'hidden', 'important');
                node.style.setProperty('opacity', '0', 'important');
                node.style.setProperty('height', '0', 'important');
              } else if (node.querySelector && node.querySelector('.native-variants-color')) {
                shouldHide = true;
                // Hide any color variants inside
                const innerVariants = node.querySelectorAll('.native-variants-color');
                innerVariants.forEach(v => {
                  v.style.setProperty('display', 'none', 'important');
                  v.style.setProperty('visibility', 'hidden', 'important');
                  v.style.setProperty('opacity', '0', 'important');
                  v.style.setProperty('height', '0', 'important');
                });
              }
            }
          });
        }
        
        // Also check if attributes changed (like style being removed)
        if (mutation.type === 'attributes' && mutation.target.classList && mutation.target.classList.contains('native-variants-color')) {
          shouldHide = true;
        }
      });

      if (shouldHide) {
        console.log('Quickview: Detected color variant added/modified, hiding immediately...');
        // Hide immediately and multiple times to ensure it sticks
        hideAnyColorVariants();
        setTimeout(hideAnyColorVariants, 0);
        setTimeout(hideAnyColorVariants, 10);
        setTimeout(hideAnyColorVariants, 50);
      }
    });

    // Observe the entire productInfo for any additions AND attribute changes
    aggressiveObserver.observe(productInfo, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class']
    });

    // Also observe the modal content container directly
    const modalContent = quickviewModal.querySelector('[data-product-upsell-ajax]');
    if (modalContent) {
      const contentObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            setTimeout(hideAnyColorVariants, 0);
            setTimeout(hideAnyColorVariants, 10);
            setTimeout(hideAnyColorVariants, 50);
          }
        });
      });
      
      contentObserver.observe(modalContent, {
        childList: true,
        subtree: true
      });
      
      console.log('Quickview: Content observer also attached for color variants');
    }

    console.log('Quickview: Aggressive color variant observer attached to product-info');
    
    return aggressiveObserver;
  }

  function initQuickviewVariantUpdate() {
    // Find product-info inside the quickview modal
    const quickviewModal = document.querySelector('[data-quick-add-modal][open]');
    if (!quickviewModal) {
      console.log('Quickview: Modal not found or not open');
      return;
    }

    const productInfo = quickviewModal.querySelector('product-info');
    if (!productInfo) {
      console.log('Quickview: product-info not found in modal');
      return;
    }
    
    // Store the last selected size value to use when button is clicked
    let lastSelectedSizeValue = null;
    
    // Try to read initial size from DOM
    const initialVariantSelects = productInfo.querySelector('variant-selects');
    if (initialVariantSelects) {
      const sizeRadios = initialVariantSelects.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="option2"]');
      const checkedSizeRadio = Array.from(sizeRadios).find(input => input.checked);
      if (checkedSizeRadio && checkedSizeRadio.value) {
        lastSelectedSizeValue = checkedSizeRadio.value;
        console.log('Quickview: Initial size from DOM:', lastSelectedSizeValue);
      }
    }

    // Mark modal with dynamic attribute and hide color variants if siblings exist
    markModalWithSiblingsAttribute();
    hideColorVariantsInQuickview();
    
    // Set up aggressive observer to catch color variants when they're added
    setupAggressiveColorVariantObserver();

    // Track if this was already initialized (for re-execution after reload)
    const wasAlreadyInitialized = initializedProductInfos.has(productInfo);
    if (wasAlreadyInitialized) {
      console.log('Quickview: Already initialized for this product-info, but content may have reloaded - will re-setup');
    }

    console.log('Quickview: Initializing variant update for product-info', productInfo);

    // Get product JSON
    const productJsonScript = productInfo.querySelector('[data-product-json]');
    if (!productJsonScript) {
      console.warn('Quickview: product JSON script not found in productInfo:', productInfo);
      console.warn('Quickview: Available scripts:', productInfo.querySelectorAll('script'));
      return;
    }

    console.log('Quickview: Found product JSON script:', productJsonScript);

    let productData;
    try {
      const jsonText = productJsonScript.textContent || productJsonScript.innerHTML;
      console.log('Quickview: JSON text length:', jsonText ? jsonText.length : 0);
      console.log('Quickview: JSON text preview:', jsonText ? jsonText.substring(0, 200) : 'empty');
      
      if (!jsonText || jsonText.trim().length === 0) {
        console.error('Quickview: JSON text is empty!');
        return;
      }
      
      productData = JSON.parse(jsonText);
      console.log('Quickview: Product data loaded successfully:', productData.id);
      console.log('Quickview: Product has', productData.variants ? productData.variants.length : 0, 'variants');
      console.log('Quickview: Product has options:', productData.options ? productData.options.length : 0);
      
      // Build options_with_values from variants and options if not present
      if (!productData.options_with_values || productData.options_with_values.length === 0) {
        console.log('Quickview: options_with_values not in JSON, building from variants and options...');
        
        if (productData.options && productData.variants) {
          productData.options_with_values = productData.options.map((option, index) => {
            const position = index + 1;
            // Get unique values for this option from all variants
            const values = [...new Set(productData.variants.map(v => v.options && v.options[index]).filter(Boolean))];
            
            return {
              name: option.name || option,
              position: position,
              values: values
            };
          });
          
          console.log('Quickview: Built options_with_values:', productData.options_with_values.length, 'options');
          console.log('Quickview: Options:', productData.options_with_values.map(o => ({ name: o.name, position: o.position, values: o.values ? o.values.length : 0 })));
        } else {
          console.error('Quickview: Cannot build options_with_values - missing options or variants');
          console.error('Quickview: productData keys:', Object.keys(productData));
        }
      } else {
        console.log('Quickview: Options:', productData.options_with_values.map(o => ({ name: o.name, position: o.position, values: o.values ? o.values.length : 0 })));
      }
    } catch (e) {
      console.error('Quickview: Error parsing product JSON:', e);
      console.error('Quickview: JSON text that failed:', productJsonScript.textContent ? productJsonScript.textContent.substring(0, 500) : 'empty');
      return;
    }

    // Store productData in a way that's always accessible
    const getProductData = function() {
      if (!productData) {
        console.warn('Quickview: productData is null/undefined, trying to reload...');
        try {
          const jsonScript = productInfo.querySelector('[data-product-json]');
          if (jsonScript) {
            productData = JSON.parse(jsonScript.textContent);
            console.log('Quickview: Reloaded productData:', productData.id);
          }
        } catch (e) {
          console.error('Quickview: Failed to reload productData:', e);
        }
      }
      return productData;
    };

    // Function to find variant by selected options
    // Optionally accepts a specific size value to use instead of reading from DOM
    function findVariantByOptions(overrideSizeValue) {
      const variantSelects = productInfo.querySelector('variant-selects');
      if (!variantSelects) {
        console.warn('Quickview: variant-selects not found');
        return null;
      }

      // Get productData (with fallback reload)
      const currentProductData = getProductData();
      
      // ALWAYS read from DOM - don't trust data-selected-variant as it may be stale
      if (!currentProductData || !currentProductData.options_with_values) {
        console.warn('Quickview: productData or options_with_values not available. productData:', currentProductData);
        return null;
      }

      const selectedOptions = [];

      // Check if product__siblings exists and get color from hidden input
      const productSiblings = productInfo.querySelector('.product__siblings');
      let siblingsColor = null;
      if (productSiblings) {
        // Try to find the hidden input with the color value
        const colorInput = productSiblings.querySelector('input[type="hidden"][name*="properties"]');
        if (colorInput && colorInput.value) {
          siblingsColor = colorInput.value.trim();
          console.log('Quickview: Found color from product__siblings hidden input:', siblingsColor);
        }
        
        // Also try to find selected swatch/radio in siblings
        if (!siblingsColor) {
          const selectedSibling = productSiblings.querySelector('input[type="radio"]:checked, [class*="swatch"][aria-checked="true"], [class*="selected"]');
          if (selectedSibling) {
            // Try to get color from data attributes or text
            siblingsColor = selectedSibling.getAttribute('data-color') || 
                          selectedSibling.getAttribute('data-value') ||
                          selectedSibling.value ||
                          selectedSibling.textContent?.trim();
            if (siblingsColor) {
              console.log('Quickview: Found color from product__siblings selected element:', siblingsColor);
            }
          }
        }
      }

      // Get options in the correct order based on currentProductData.options_with_values
      currentProductData.options_with_values.forEach((option) => {
        const optionName = option.name;
        const optionPosition = option.position;
        let selectedValue = null;

        // SPECIAL CASE: If this is the Size option (position 2) and we have an override value, use it FIRST
        if (optionPosition === 2 && overrideSizeValue && (optionName.toLowerCase() === 'size' || optionName.toLowerCase() === 'talla')) {
          // Check if overrideSizeValue matches any of the option values
          const matchingValue = option.values.find(val => 
            val && val.toString().toLowerCase() === overrideSizeValue.toLowerCase()
          );
          if (matchingValue) {
            selectedValue = matchingValue;
            console.log(`Quickview: Option "${optionName}" (position ${optionPosition}) selected from override value:`, selectedValue);
          } else {
            console.log(`Quickview: overrideSizeValue "${overrideSizeValue}" doesn't match option values, trying DOM...`);
          }
        }

        // SPECIAL CASE: If this is the Color option (position 1) and we have siblingsColor, use it
        if (optionPosition === 1 && siblingsColor && (optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour')) {
          // Check if siblingsColor matches any of the option values
          const matchingValue = option.values.find(val => 
            val && val.toString().toLowerCase() === siblingsColor.toLowerCase()
          );
          if (matchingValue) {
            selectedValue = matchingValue;
            console.log(`Quickview: Option "${optionName}" (position ${optionPosition}) selected from product__siblings:`, selectedValue);
          } else {
            console.log(`Quickview: siblingsColor "${siblingsColor}" doesn't match option values, trying other methods...`);
          }
        }

        // Try radio buttons (most common)
        if (!selectedValue) {
          const radioInputs = variantSelects.querySelectorAll(`input[type="radio"][name*="${optionName}"], input[type="radio"][name*="option${optionPosition}"]`);
          console.log(`Quickview: Looking for option "${optionName}" (position ${optionPosition}) - found ${radioInputs.length} radio inputs`);
          const checkedRadio = Array.from(radioInputs).find(input => input.checked);
          if (checkedRadio && checkedRadio.value) {
            selectedValue = checkedRadio.value;
            console.log(`Quickview: Option "${optionName}" (position ${optionPosition}) selected via radio:`, selectedValue);
          } else {
            console.log(`Quickview: No checked radio found for option "${optionName}" (position ${optionPosition}). All radios:`, Array.from(radioInputs).map(r => ({ name: r.name, value: r.value, checked: r.checked })));
            
            // FALLBACK: If no radio is checked, try to find the first radio that should be checked
            // This can happen after modal reload when product__siblings changes color
            // Look for a radio with a "checked" attribute or the first one
            const firstRadio = Array.from(radioInputs).find(input => input.hasAttribute('checked') || input.getAttribute('aria-checked') === 'true');
            if (firstRadio && firstRadio.value) {
              selectedValue = firstRadio.value;
              console.log(`Quickview: Using first radio with checked attribute for option "${optionName}" (position ${optionPosition}):`, selectedValue);
            } else if (radioInputs.length > 0 && radioInputs[0].value) {
              // Last resort: use the first radio button's value
              selectedValue = radioInputs[0].value;
              console.log(`Quickview: FALLBACK - Using first radio button value for option "${optionName}" (position ${optionPosition}):`, selectedValue);
            }
          }
        }

        // Try popout input
        if (!selectedValue) {
          const popoutInput = variantSelects.querySelector(`[data-popout-input][data-index="option${optionPosition}"]`);
          if (popoutInput && popoutInput.value) {
            selectedValue = popoutInput.value;
            console.log(`Quickview: Option "${optionName}" (position ${optionPosition}) selected via popout:`, selectedValue);
          }
        }

        // Try native select
        if (!selectedValue) {
          const select = variantSelects.querySelector(`select[name*="${optionName}"], select[name*="option${optionPosition}"]`);
          if (select && select.value) {
            selectedValue = select.value;
            console.log(`Quickview: Option "${optionName}" (position ${optionPosition}) selected via select:`, selectedValue);
          }
        }

        if (!selectedValue) {
          console.warn(`Quickview: No selected value found for option "${optionName}" (position ${optionPosition})`);
          
          // If no value is selected, try to use the first available value as default
          // This is especially important after modal reload when product__siblings changes color
          if (option.values && option.values.length > 0) {
            selectedValue = option.values[0];
            console.log(`Quickview: Using first available value as default for option "${optionName}" (position ${optionPosition}):`, selectedValue);
          }
        }

        if (selectedValue) {
          selectedOptions.push(selectedValue);
        } else {
          console.error(`Quickview: CRITICAL - No value could be determined for option "${optionName}" (position ${optionPosition})`);
        }
      });

      console.log('Quickview: Selected options from DOM:', selectedOptions);
      console.log('Quickview: Number of selected options:', selectedOptions.length);
      console.log('Quickview: Expected number of options:', currentProductData.options_with_values ? currentProductData.options_with_values.length : 'unknown');

      // Find variant that matches all selected options
      if (currentProductData && currentProductData.variants && selectedOptions.length > 0) {
        console.log('Quickview: Searching through', currentProductData.variants.length, 'variants for match...');
        const matchingVariant = currentProductData.variants.find(variant => {
          if (!variant.options || variant.options.length !== selectedOptions.length) {
            console.log('Quickview: Variant', variant.id, 'options length mismatch:', variant.options?.length, 'vs', selectedOptions.length);
            return false;
          }
          const matches = variant.options.every((optionValue, index) => {
            const match = selectedOptions[index] === optionValue;
            if (!match) {
              console.log('Quickview: Variant', variant.id, 'option', index, 'mismatch:', variant.options[index], 'vs', selectedOptions[index]);
            }
            return match;
          });
          if (matches) {
            console.log('Quickview: ✅ Found matching variant:', variant.id, 'with options:', variant.options);
          }
          return matches;
        });

        if (matchingVariant) {
          console.log('Quickview: Found matching variant by options:', matchingVariant.id, 'for options:', selectedOptions);
        } else {
          console.warn('Quickview: No matching variant found for options:', selectedOptions);
          console.warn('Quickview: Available variants:', currentProductData.variants.map(v => ({ id: v.id, options: v.options })));
        }

        return matchingVariant;
      }

      return null;
    }

    // Function to update variant ID input
    function updateVariantIdInput(variantId) {
      const variantInputs = productInfo.querySelectorAll('input[name="id"]');
      console.log('Quickview: Found', variantInputs.length, 'input[name="id"] elements');
      variantInputs.forEach((input, index) => {
        if (input) {
          const oldValue = input.value;
          input.value = variantId || '';
          console.log(`Quickview: Input ${index}: Updated from "${oldValue}" to "${input.value}"`);
          if (oldValue !== input.value) {
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
      
      // Also update the form's input directly
      const form = productInfo.querySelector('form[data-product-form]');
      if (form) {
        const formVariantInput = form.querySelector('input[name="id"]');
        if (formVariantInput) {
          const oldFormValue = formVariantInput.value;
          formVariantInput.value = variantId || '';
          console.log('Quickview: Form input updated from', oldFormValue, 'to', formVariantInput.value);
        }
      }
    }

    // Function to update variant ID from selected options
    // Optionally accepts a specific size value to use instead of reading from DOM
    function updateVariantFromOptions(overrideSizeValue) {
      console.log('Quickview: Attempting to update variant from options...');
      if (overrideSizeValue) {
        console.log('Quickview: Using override size value:', overrideSizeValue);
      }
      const variant = findVariantByOptions(overrideSizeValue);
      if (variant && variant.id) {
        updateVariantIdInput(variant.id.toString());
      } else {
        console.warn('Quickview: No variant found to update ID');
      }
    }

    // Listen for variant change events
    subscribe(theme.PUB_SUB_EVENTS.variantChange, function(event) {
      console.log('Quickview: Received variantChange event', event.data);
      if (event.data && event.data.variant && event.data.variant.id) {
        const variantId = event.data.variant.id.toString();
        const eventProductInfo = document.querySelector(`product-info[data-section="${event.data.sectionId}"]`);
        if (eventProductInfo === productInfo) {
          console.log('Quickview: variantChange event matches current product-info. Updating ID.');
          updateVariantIdInput(variantId);
          // Re-hide color variants after variant change
          setTimeout(hideColorVariantsIfSiblingsExist, 100);
        }
      }
    });

    // Listen for option value selection changes
    subscribe(theme.PUB_SUB_EVENTS.optionValueSelectionChange, function(event) {
      console.log('Quickview: ========== optionValueSelectionChange EVENT ==========');
      console.log('Quickview: Received optionValueSelectionChange event', event.data);
      
      // Check if this event is for a quickview modal product
      const quickviewModal = document.querySelector('[data-quick-add-modal][open]');
      if (!quickviewModal) {
        return; // Not in quickview modal
      }
      
      const currentProductInfo = quickviewModal.querySelector('product-info');
      if (!currentProductInfo) {
        return; // No product-info in modal
      }
      
      if (event.data && event.data.target && currentProductInfo.contains(event.data.target)) {
        console.log('Quickview: optionValueSelectionChange event matches current product-info. Updating variant IMMEDIATELY.');
        console.log('Quickview: Selected option values:', event.data.selectedOptionValues);
        console.log('Quickview: Target element:', event.data.target);
        
        // CRITICAL: Get the size value directly from the target element
        // This is more reliable than reading from DOM which may not be updated yet
        const targetInput = event.data.target;
        let sizeValueOverride = null;
        if (targetInput && targetInput.name && (targetInput.name.includes('Size') || targetInput.name.includes('option2'))) {
          sizeValueOverride = targetInput.value;
          lastSelectedSizeValue = sizeValueOverride; // Store for button click handler
          console.log('Quickview: Detected size change from target element, using override value:', sizeValueOverride);
          console.log('Quickview: Stored lastSelectedSizeValue:', lastSelectedSizeValue);
        }
        
        // Update variant IMMEDIATELY using the size value from the event target
        // This ensures we use the correct size even if DOM hasn't updated yet
        updateVariantFromOptions(sizeValueOverride);
        setTimeout(function() { updateVariantFromOptions(sizeValueOverride); }, 10);
        setTimeout(function() { updateVariantFromOptions(sizeValueOverride); }, 50);
        setTimeout(function() { updateVariantFromOptions(sizeValueOverride); }, 100);
        setTimeout(function() { updateVariantFromOptions(sizeValueOverride); }, 200);
        
        // Re-hide color variants after option change
        setTimeout(hideColorVariantsIfSiblingsExist, 150);
      } else {
        console.log('Quickview: optionValueSelectionChange event does not match current product-info or no target');
      }
    });

    // Intercept button click DIRECTLY - this happens BEFORE form submit and theme:cart:add
    // Use event delegation on the modal to catch clicks even after reload
    const quickviewModalForButton = document.querySelector('[data-quick-add-modal][open]');
    if (quickviewModalForButton) {
      const buttonClickHandler = function(e) {
        // Only handle clicks on the submit button
        const clickedButton = e.target.closest('button[type="submit"][data-add-to-cart]');
        if (!clickedButton) {
          return;
        }
        
        // Find the current productInfo dynamically
        const currentProductInfo = quickviewModalForButton.querySelector('product-info');
        if (!currentProductInfo) {
          return;
        }
        
        console.log('Quickview: ========== BUTTON CLICKED ==========');
        console.log('Quickview: Intercepting button click (CAPTURE PHASE). Updating variant ID BEFORE any other handlers.');
        
        // Get the current lastSelectedSizeValue from the closure or read from DOM
        // We need to access lastSelectedSizeValue, but it's in the closure
        // So we'll read it from the DOM or use a global approach
        const currentVariantSelects = currentProductInfo.querySelector('variant-selects');
        let currentSizeValue = null;
        if (currentVariantSelects) {
          const sizeRadios = currentVariantSelects.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="option2"]');
          const checkedSizeRadio = Array.from(sizeRadios).find(input => input.checked);
          if (checkedSizeRadio && checkedSizeRadio.value) {
            currentSizeValue = checkedSizeRadio.value;
            console.log('Quickview: Read current size from DOM:', currentSizeValue);
          }
        }
        
        // CRITICAL: Force update variant ID SYNCHRONOUSLY - this must happen BEFORE FormData is created
        // Use the size value we just read
        console.log('Quickview: Calling updateVariantFromOptions with size:', currentSizeValue);
        
        // Get product data from currentProductInfo (not from closure)
        let currentProductData = null;
        try {
          const jsonScript = currentProductInfo.querySelector('[data-product-json]');
          if (jsonScript) {
            currentProductData = JSON.parse(jsonScript.textContent);
            console.log('Quickview: Loaded productData from currentProductInfo in button click:', currentProductData.id);
          } else {
            console.warn('Quickview: No product JSON script found in currentProductInfo');
          }
        } catch (e) {
          console.error('Quickview: Error parsing product JSON in button click:', e);
        }
        
        if (!currentProductData || !currentProductData.options_with_values) {
          console.warn('Quickview: Product data not available in button click. productData:', currentProductData);
          // Try to build options_with_values if missing
          if (currentProductData && currentProductData.options && currentProductData.variants) {
            currentProductData.options_with_values = currentProductData.options.map((optionName, index) => {
              const position = index + 1;
              const values = [...new Set(currentProductData.variants.map(v => v.options[index]))];
              return { name: optionName, position: position, values: values };
            });
            console.log('Quickview: Built options_with_values in button click');
          } else {
            return;
          }
        }
        
        // Get color from product__siblings
        const productSiblings = currentProductInfo.querySelector('.product__siblings');
        let siblingsColor = null;
        if (productSiblings) {
          const colorInput = productSiblings.querySelector('input[type="hidden"][name*="properties"]');
          if (colorInput && colorInput.value) {
            siblingsColor = colorInput.value.trim();
          }
        }
        
        // Build selected options
        const selectedOptions = [];
        currentProductData.options_with_values.forEach((option) => {
          const optionName = option.name;
          const optionPosition = option.position;
          let selectedValue = null;
          
          // Use override size if this is the size option
          if (optionPosition === 2 && currentSizeValue && (optionName.toLowerCase() === 'size' || optionName.toLowerCase() === 'talla')) {
            const matchingValue = option.values.find(val => 
              val && val.toString().toLowerCase() === currentSizeValue.toLowerCase()
            );
            if (matchingValue) {
              selectedValue = matchingValue;
            }
          }
          
          // Use color from siblings if this is the color option
          if (optionPosition === 1 && siblingsColor && (optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour')) {
            const matchingValue = option.values.find(val => 
              val && val.toString().toLowerCase() === siblingsColor.toLowerCase()
            );
            if (matchingValue) {
              selectedValue = matchingValue;
            }
          }
          
          // Fallback to reading from DOM
          if (!selectedValue) {
            const radioInputs = currentVariantSelects.querySelectorAll(`input[type="radio"][name*="${optionName}"], input[type="radio"][name*="option${optionPosition}"]`);
            const checkedRadio = Array.from(radioInputs).find(input => input.checked);
            if (checkedRadio && checkedRadio.value) {
              selectedValue = checkedRadio.value;
            }
          }
          
          if (selectedValue) {
            selectedOptions.push(selectedValue);
          }
        });
        
        // Find matching variant
        const variant = currentProductData.variants.find(v => {
          if (v.options.length !== selectedOptions.length) return false;
          return v.options.every((opt, idx) => opt === selectedOptions[idx]);
        });
        
        if (variant && variant.id) {
          const variantId = variant.id.toString();
          console.log('Quickview: Button clicked - updating variant ID to:', variantId);
          console.log('Quickview: Selected options:', selectedOptions);
          
          // Update all variant inputs
          const variantInputs = currentProductInfo.querySelectorAll('input[name="id"]');
          variantInputs.forEach(input => {
            input.value = variantId;
          });
          
          // Triple-check that the input was updated
          const form = clickedButton.form || clickedButton.closest('form');
          if (form) {
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput) {
              const actualInputValue = variantInput.value;
              console.log('Quickview: Actual input value in DOM:', actualInputValue);
              if (actualInputValue !== variantId) {
                console.error('Quickview: ERROR - Input value mismatch! Force updating...');
                variantInput.value = variantId;
              }
            }
            
            // Also check FormData
            const formData = new FormData(form);
            const formDataVariantId = formData.get('id');
            console.log('Quickview: FormData variant ID after update:', formDataVariantId);
            if (formDataVariantId !== variantId) {
              console.error('Quickview: ERROR - FormData variant ID mismatch! Force updating...');
              const variantInput2 = form.querySelector('input[name="id"]');
              if (variantInput2) {
                variantInput2.value = variantId;
              }
            }
          }
        } else {
          console.error('Quickview: CRITICAL ERROR - No variant found when button clicked!');
        }
      };
      
      quickviewModalForButton.addEventListener('click', buttonClickHandler, true); // Capture phase - runs FIRST
      console.log('Quickview: Button click listener attached to modal (event delegation)');
    }

    // Intercept form submission
    const form = productInfo.querySelector('form[data-product-form]');
    if (form) {
      form.addEventListener('submit', function(e) {
        console.log('Quickview: Intercepting form submission. Updating variant ID before submit.');
        console.log('Quickview: Using stored lastSelectedSizeValue in form submit:', lastSelectedSizeValue);
        updateVariantFromOptions(lastSelectedSizeValue);
      }, true); // Use capture phase
    }

    // Intercept the cart add event VERY EARLY (backup)
    const cartAddHandler = function(event) {
      // Find the current quickview modal and productInfo dynamically
      const currentQuickviewModal = document.querySelector('[data-quick-add-modal][open]');
      if (!currentQuickviewModal) {
        return; // Not in quickview
      }
      
      const currentProductInfo = currentQuickviewModal.querySelector('product-info');
      if (!currentProductInfo) {
        return; // No product-info in modal
      }
      
      const button = event.detail?.button;
      if (!button || !currentProductInfo.contains(button)) {
        return;
      }

      console.log('Quickview: ========== theme:cart:add EVENT ==========');
      console.log('Quickview: Intercepting theme:cart:add event. Updating variant ID before cart add.');
      
      // Read current size from DOM
      const currentVariantSelects = currentProductInfo.querySelector('variant-selects');
      let currentSizeValue = null;
      if (currentVariantSelects) {
        const sizeRadios = currentVariantSelects.querySelectorAll('input[type="radio"][name*="Size"], input[type="radio"][name*="option2"]');
        const checkedSizeRadio = Array.from(sizeRadios).find(input => input.checked);
        if (checkedSizeRadio && checkedSizeRadio.value) {
          currentSizeValue = checkedSizeRadio.value;
          console.log('Quickview: Read current size from DOM in cart:add:', currentSizeValue);
        }
      }
      
      // Get product data from currentProductInfo (not from closure)
      let currentProductData = null;
      try {
        const jsonScript = currentProductInfo.querySelector('[data-product-json]');
        if (jsonScript) {
          currentProductData = JSON.parse(jsonScript.textContent);
          console.log('Quickview: Loaded productData from currentProductInfo:', currentProductData.id);
        } else {
          console.warn('Quickview: No product JSON script found in currentProductInfo');
        }
      } catch (e) {
        console.error('Quickview: Error parsing product JSON in cart:add:', e);
      }
      
      if (!currentProductData || !currentProductData.options_with_values) {
        console.warn('Quickview: Product data not available in cart:add. productData:', currentProductData);
        // Try to build options_with_values if missing
        if (currentProductData && currentProductData.options && currentProductData.variants) {
          currentProductData.options_with_values = currentProductData.options.map((optionName, index) => {
            const position = index + 1;
            const values = [...new Set(currentProductData.variants.map(v => v.options[index]))];
            return { name: optionName, position: position, values: values };
          });
          console.log('Quickview: Built options_with_values in cart:add');
        } else {
          return;
        }
      }
      
      // Get color from product__siblings
      const productSiblings = currentProductInfo.querySelector('.product__siblings');
      let siblingsColor = null;
      if (productSiblings) {
        const colorInput = productSiblings.querySelector('input[type="hidden"][name*="properties"]');
        if (colorInput && colorInput.value) {
          siblingsColor = colorInput.value.trim();
        }
      }
      
      // Build selected options
      const selectedOptions = [];
      currentProductData.options_with_values.forEach((option) => {
        const optionName = option.name;
        const optionPosition = option.position;
        let selectedValue = null;
        
        // Use current size if this is the size option
        if (optionPosition === 2 && currentSizeValue && (optionName.toLowerCase() === 'size' || optionName.toLowerCase() === 'talla')) {
          const matchingValue = option.values.find(val => 
            val && val.toString().toLowerCase() === currentSizeValue.toLowerCase()
          );
          if (matchingValue) {
            selectedValue = matchingValue;
          }
        }
        
        // Use color from siblings if this is the color option
        if (optionPosition === 1 && siblingsColor && (optionName.toLowerCase() === 'color' || optionName.toLowerCase() === 'colour')) {
          const matchingValue = option.values.find(val => 
            val && val.toString().toLowerCase() === siblingsColor.toLowerCase()
          );
          if (matchingValue) {
            selectedValue = matchingValue;
          }
        }
        
        // Fallback to reading from DOM
        if (!selectedValue) {
          const radioInputs = currentVariantSelects.querySelectorAll(`input[type="radio"][name*="${optionName}"], input[type="radio"][name*="option${optionPosition}"]`);
          const checkedRadio = Array.from(radioInputs).find(input => input.checked);
          if (checkedRadio && checkedRadio.value) {
            selectedValue = checkedRadio.value;
          }
        }
        
        if (selectedValue) {
          selectedOptions.push(selectedValue);
        }
      });
      
      // Find matching variant
      const variant = currentProductData.variants.find(v => {
        if (v.options.length !== selectedOptions.length) return false;
        return v.options.every((opt, idx) => opt === selectedOptions[idx]);
      });
      
      if (variant && variant.id) {
        const variantId = variant.id.toString();
        console.log('Quickview: Updating variant ID in cart:add handler to:', variantId);
        console.log('Quickview: Selected options:', selectedOptions);
        
        // Update all variant inputs
        const variantInputs = currentProductInfo.querySelectorAll('input[name="id"]');
        variantInputs.forEach(input => {
          input.value = variantId;
        });
        
        // Double-check the input was updated
        const form = currentProductInfo.querySelector('form[data-product-form]');
        if (form) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput && variantInput.value !== variantId) {
            console.error('Quickview: ERROR in cart:add - Input value mismatch! Force updating...');
            variantInput.value = variantId;
            console.log('Quickview: Force-updated input in cart:add handler to:', variantId);
          }
        }
      } else {
        console.error('Quickview: CRITICAL ERROR - No variant found in cart:add handler!');
      }
    };

    document.addEventListener('theme:cart:add', cartAddHandler, true); // Use capture phase

    // Simple approach: If product__siblings exists, hide color variants permanently with CSS
    function hideColorVariantsIfSiblingsExist() {
      // Look for product__siblings within the productInfo (quickview modal)
      const productSiblings = productInfo.querySelector('.product__siblings');
      const siblingsExists = !!productSiblings;

      // Also check for pl-swatches-embed-copied (another app that might be used)
      const plSwatchesEmbed = productInfo.querySelector('#pl-swatches-embed-copied');
      const plSwatchesExists = !!plSwatchesEmbed;

      console.log('Quickview: Checking for color variant apps:');
      console.log('- product__siblings exists:', siblingsExists);
      console.log('- pl-swatches-embed-copied exists:', plSwatchesExists);

      // Find all color variant selectors within the productInfo
      const colorVariants = productInfo.querySelectorAll('.native-variants-color');

      if (colorVariants.length > 0) {
        // Simple rule: If product__siblings OR pl-swatches-embed-copied exists, hide color variants
        if (siblingsExists || plSwatchesExists) {
          // Apps detected - HIDE native color variants with !important to override any other styles
          colorVariants.forEach(variant => {
            variant.style.setProperty('display', 'none', 'important');
            variant.style.setProperty('visibility', 'hidden', 'important');
            variant.style.setProperty('opacity', '0', 'important');
            variant.style.setProperty('height', '0', 'important');
            variant.style.setProperty('overflow', 'hidden', 'important');
            variant.style.setProperty('margin', '0', 'important');
            variant.style.setProperty('padding', '0', 'important');
          });
          console.log('Quickview: ✅ Color variants hidden (product__siblings or pl-swatches detected)');
        } else {
          // No apps detected - SHOW native color variants
          colorVariants.forEach(variant => {
            variant.style.removeProperty('display');
            variant.style.removeProperty('visibility');
            variant.style.removeProperty('opacity');
            variant.style.removeProperty('height');
            variant.style.removeProperty('overflow');
            variant.style.removeProperty('margin');
            variant.style.removeProperty('padding');
          });
          console.log('Quickview: ✅ Color variants shown (no app detected)');
        }
      } else {
        console.log('Quickview: No color variant selectors found in quickview');
      }
    }

    // Execute immediately and repeatedly to catch dynamically loaded content
    // Use a more aggressive approach with multiple checks
    hideColorVariantsIfSiblingsExist();
    setTimeout(hideColorVariantsIfSiblingsExist, 50);
    setTimeout(hideColorVariantsIfSiblingsExist, 100);
    setTimeout(hideColorVariantsIfSiblingsExist, 200);
    setTimeout(hideColorVariantsIfSiblingsExist, 400);
    setTimeout(hideColorVariantsIfSiblingsExist, 600);
    setTimeout(hideColorVariantsIfSiblingsExist, 1000);

    // Also watch for changes in product__siblings content
    const productSiblings = productInfo.querySelector('.product__siblings');
    if (productSiblings) {
      const siblingsObserver = new MutationObserver(function(mutations) {
        const hasRelevantChange = mutations.some(mutation => {
          if (mutation.type === 'childList') {
            // Check if any nodes were added (content loading)
            return mutation.addedNodes.length > 0;
          }
          if (mutation.type === 'attributes') {
            // Check if visibility or display changed
            return mutation.attributeName === 'style' || mutation.attributeName === 'class';
          }
          return false;
        });

        if (hasRelevantChange) {
          console.log('Quickview: product__siblings content changed, rechecking color variants...');
          // Execute multiple times to catch content as it loads
          hideColorVariantsIfSiblingsExist();
          setTimeout(hideColorVariantsIfSiblingsExist, 100);
          setTimeout(hideColorVariantsIfSiblingsExist, 300);
          setTimeout(hideColorVariantsIfSiblingsExist, 500);
        }
      });
      siblingsObserver.observe(productSiblings, {
        childList: true,
        subtree: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
      console.log('Quickview: product__siblings observer attached');
    }

    // Watch for changes in native-variants-color elements (when they're shown/hidden by theme)
    const colorVariants = productInfo.querySelectorAll('.native-variants-color');
    colorVariants.forEach(colorVariant => {
      const variantObserver = new MutationObserver(function(mutations) {
        // Check if display style changed or class was added/removed
        const hasDisplayChange = mutations.some(mutation => 
          mutation.type === 'attributes' && 
          (mutation.attributeName === 'style' || mutation.attributeName === 'class')
        );
        
        if (hasDisplayChange) {
          console.log('Quickview: native-variants-color element changed, rechecking visibility...');
          // Small delay to let the theme finish its changes
          setTimeout(hideColorVariantsIfSiblingsExist, 50);
        }
      });
      
      variantObserver.observe(colorVariant, {
        attributes: true,
        attributeFilter: ['style', 'class'],
        childList: true,
        subtree: false
      });
    });

    // Also observe the variant-selects container for any changes
    const variantSelects = productInfo.querySelector('variant-selects');
    if (variantSelects) {
      const variantSelectsObserver = new MutationObserver(function(mutations) {
        // Check if any native-variants-color elements were added or modified
        const hasRelevantChange = mutations.some(mutation => {
          if (mutation.type === 'childList') {
            // Check if any added nodes are native-variants-color
            const addedNodes = Array.from(mutation.addedNodes);
            return addedNodes.some(node => 
              node.nodeType === 1 && 
              (node.classList?.contains('native-variants-color') || 
               node.querySelector?.('.native-variants-color'))
            );
          }
          if (mutation.type === 'attributes' && mutation.target.classList?.contains('native-variants-color')) {
            return true;
          }
          return false;
        });
        
        if (hasRelevantChange) {
          console.log('Quickview: variant-selects changed, rechecking color variants...');
          setTimeout(hideColorVariantsIfSiblingsExist, 100);
        }
      });
      
      variantSelectsObserver.observe(variantSelects, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'class']
      });
    }

    // Set up a continuous interval to keep color variants hidden if product__siblings exists
    // This ensures they stay hidden even if the theme tries to show them
    let hideInterval = null;
    const productSiblingsCheck = productInfo.querySelector('.product__siblings');
    const plSwatchesCheck = productInfo.querySelector('#pl-swatches-embed-copied');
    
    if (productSiblingsCheck || plSwatchesCheck) {
      // If app exists, continuously check and hide color variants
      hideInterval = setInterval(function() {
        hideColorVariantsInQuickview();
      }, 50); // Check every 50ms for more aggressive hiding
      console.log('Quickview: Continuous hide interval started');
      
      // Also use MutationObserver to catch when variants are added to DOM
      const modalContent = quickviewModal.querySelector('[data-product-upsell-ajax]');
      if (modalContent) {
        const aggressiveObserver = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            if (mutation.addedNodes.length > 0) {
              // New nodes added - immediately hide color variants
              setTimeout(hideColorVariantsInQuickview, 0);
              setTimeout(hideColorVariantsInQuickview, 10);
              setTimeout(hideColorVariantsInQuickview, 50);
            }
          });
        });
        aggressiveObserver.observe(modalContent, {
          childList: true,
          subtree: true
        });
        console.log('Quickview: Aggressive observer attached to modal content');
      }
    }

    // Mark as initialized (only if not already initialized)
    if (!wasAlreadyInitialized) {
      initializedProductInfos.add(productInfo);
      console.log('Quickview: All listeners attached successfully');
    } else {
      console.log('Quickview: Re-initializing after content reload - re-executing hideColorVariantsIfSiblingsExist');
      // Re-execute hideColorVariantsIfSiblingsExist since content was reloaded
      setTimeout(hideColorVariantsIfSiblingsExist, 50);
      setTimeout(hideColorVariantsIfSiblingsExist, 100);
      setTimeout(hideColorVariantsIfSiblingsExist, 200);
      setTimeout(hideColorVariantsIfSiblingsExist, 400);
      setTimeout(hideColorVariantsIfSiblingsExist, 600);
      setTimeout(hideColorVariantsIfSiblingsExist, 1000);
    }
    
    // Clean up interval when modal closes
    const modalContainer = productInfo.closest('[data-quick-add-modal]');
    if (modalContainer && hideInterval) {
      const modalCloseObserver = new MutationObserver(function(mutations) {
        if (!modalContainer.hasAttribute('open')) {
          clearInterval(hideInterval);
          modalCloseObserver.disconnect();
          console.log('Quickview: Hide interval cleared (modal closed)');
        }
      });
      modalCloseObserver.observe(modalContainer, {
        attributes: true,
        attributeFilter: ['open']
      });
    }

    // Initial update in case options are pre-selected
    updateVariantFromOptions();
    
    // Also set up delayed updates to catch options after they're fully loaded
    // This is especially important after modal content reloads (e.g., when changing color in siblings)
    setTimeout(function() {
      console.log('Quickview: Delayed variant update after initialization (300ms)...');
      updateVariantFromOptions();
    }, 300);
    
    setTimeout(function() {
      console.log('Quickview: Second delayed variant update (600ms)...');
      updateVariantFromOptions();
    }, 600);
    
    // Also listen for changes in size selection after reload
    // This is critical when color is changed in product__siblings and modal reloads
    const variantSelectsReload = productInfo.querySelector('variant-selects');
    if (variantSelectsReload) {
      // Function to attach listeners to all radio inputs
      function attachOptionListeners() {
        const allOptionInputs = variantSelectsReload.querySelectorAll('input[type="radio"]');
        allOptionInputs.forEach(function(input) {
          // Check if listener already attached (using a data attribute)
          if (!input.hasAttribute('data-quickview-listener-attached')) {
            input.setAttribute('data-quickview-listener-attached', 'true');
            
            // Use capture phase to run BEFORE other handlers
            input.addEventListener('change', function(e) {
              console.log('Quickview: ========== OPTION CHANGED ==========');
              console.log('Quickview: Option changed after reload:', input.name, '=', input.value);
              console.log('Quickview: Input element:', input);
              console.log('Quickview: All radio inputs in variant-selects:', variantSelectsReload.querySelectorAll('input[type="radio"]').length);
              console.log('Quickview: Current checked inputs:', Array.from(variantSelectsReload.querySelectorAll('input[type="radio"]:checked')).map(i => ({ name: i.name, value: i.value, id: i.id })));
              
              // If this is a size change, save it
              if (input.name && (input.name.includes('Size') || input.name.includes('option2'))) {
                lastSelectedSize = input.value;
                console.log('Quickview: Saved selected size:', lastSelectedSize);
              }
              
              // Force a small delay to ensure DOM is updated
              setTimeout(function() {
                console.log('Quickview: After delay - checked inputs:', Array.from(variantSelectsReload.querySelectorAll('input[type="radio"]:checked')).map(i => ({ name: i.name, value: i.value })));
                
                // Update variant IMMEDIATELY and multiple times
                updateVariantFromOptions();
                setTimeout(updateVariantFromOptions, 10);
                setTimeout(updateVariantFromOptions, 50);
                setTimeout(updateVariantFromOptions, 100);
                setTimeout(updateVariantFromOptions, 200);
              }, 5);
            }, true); // Use capture phase - runs FIRST
            
            // Also listen in bubble phase as backup
            input.addEventListener('change', function(e) {
              console.log('Quickview: Option changed (bubble phase):', input.name, '=', input.value);
              setTimeout(updateVariantFromOptions, 50);
              setTimeout(updateVariantFromOptions, 150);
            }, false);
          }
        });
        console.log('Quickview: Option change listeners attached:', allOptionInputs.length, 'inputs');
      }
      
      // Wait a bit for the DOM to be ready, then set up listeners
      setTimeout(attachOptionListeners, 400);
      setTimeout(attachOptionListeners, 800);
      setTimeout(attachOptionListeners, 1200);
      
      // Also set up a MutationObserver to catch when inputs are added/changed
      const variantSelectsObserver = new MutationObserver(function(mutations) {
        let shouldAttach = false;
        mutations.forEach(function(mutation) {
          if (mutation.addedNodes.length > 0) {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                if (node.tagName === 'INPUT' && node.type === 'radio') {
                  shouldAttach = true;
                } else if (node.querySelectorAll && node.querySelectorAll('input[type="radio"]').length > 0) {
                  shouldAttach = true;
                }
              }
            });
          }
        });
        
        if (shouldAttach) {
          console.log('Quickview: New radio inputs detected, attaching listeners...');
          setTimeout(attachOptionListeners, 50);
          setTimeout(attachOptionListeners, 200);
        }
      });
      
      variantSelectsObserver.observe(variantSelectsReload, {
        childList: true,
        subtree: true
      });
      console.log('Quickview: MutationObserver attached to variant-selects for dynamic inputs');
    }
  }

  // Also try to initialize on page load in case modal is already open
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      setTimeout(initQuickviewVariantUpdate, 200);
    });
  } else {
    setTimeout(initQuickviewVariantUpdate, 200);
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
